module.exports = __webpack_public_path__ + "static/media/Logo.a49b07ec.svg";